<template>
  <div class="header">
    <div class="header_box">
      <div class="header_box_info">
        <div class="header_box_info_l" id="time"></div>

        <div class="header_box_info_r">
          <el-dropdown trigger="hover" placement="bottom" @command="dropdowncommand">
            <div class="header_box_info_r_item">
              <img src="@/assets/images/public/avator.png" alt="">
              <span>{{ userinfo.username }}</span>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="1">个人中心</el-dropdown-item>
              <el-dropdown-item command="2">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="header_box_nav">
        <div :class="['header_box_nav', activeMainMenu == mainMenuItems[0].route ? 'header_box_nav_act' : '']"
          @click="selectMainMenu(mainMenuItems[0])">劳动力总况</div>
        <el-dropdown trigger="hover" placement="bottom" @command="dropdowncommand" v-if="false">
          <div :class="['header_box_nav', activeMainMenu == mainMenuItems[1].route ? 'header_box_nav_act' : '']"
            @click="selectMainMenu(mainMenuItems[1])">重点人群分析</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="21">已就业人员</el-dropdown-item>
            <el-dropdown-item command="22">未就业人员</el-dropdown-item>
            <el-dropdown-item command="23">高校毕业生</el-dropdown-item>
            <el-dropdown-item command="24">外出务工人员</el-dropdown-item>
            <el-dropdown-item command="25">退役军人</el-dropdown-item>
            <el-dropdown-item command="26">残疾人</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div :class="['header_box_nav', activeMainMenu == mainMenuItems[2].route ? 'header_box_nav_act' : '']"
          @click="selectMainMenu(mainMenuItems[2])">万能台账</div>
        <el-dropdown trigger="hover" placement="bottom" @command="dropdowncommand">
          <div :class="['header_box_nav', activeMainMenu == mainMenuItems[3].route ? 'header_box_nav_act' : '']"
            @click="selectMainMenu(mainMenuItems[3])">劳动力查询</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="41">劳动力全景画像</el-dropdown-item>
            <el-dropdown-item command="42">劳动力资源查询</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown trigger="hover" placement="bottom" @command="dropdowncommand">
          <div :class="['header_box_nav', activeMainMenu == mainMenuItems[4].route ? 'header_box_nav_act' : '']"
            @click="selectMainMenu(mainMenuItems[4])">采集分析</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="51">采集更新进度</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <!-- <div :class="['header_box_nav', activeMainMenu == mainMenuItems[5].route ? 'header_box_nav_act' : '']"
          @click="selectMainMenu(mainMenuItems[5])">物流大屏</div> -->
        <el-dropdown trigger="hover" placement="bottom" @command="dropdowncommand">
          <div :class="['header_box_nav', activeMainMenu == mainMenuItems[6].route ? 'header_box_nav_act' : '']"
            @click="selectMainMenu(mainMenuItems[6])">系统设置</div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="71">登录日志</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
  props: ["navArr", "index"],
  data() {
    return {
      popupObj: {
        flag: false,
        title: "温馨提示",
        content: "是否对当前账号退出登录操作？",
        btn1: "确认",
        btn2: "取消",
      },
      urls: this.imgurl,
      userinfo: {},
      nav: [],
      navId: null,
      activeMainMenu: '', // 默认选中活动管理
      mainMenuItems: [
        { id: 1, name: "劳动力总况", route: "/index" },
        { id: 2, name: "重点人群分析", route: "/mployed" },
        { id: 3, name: "万能台账", route: "/universalParameter" },
        { id: 4, name: "劳动力查询", route: "/portrait" },
        { id: 5, name: "采集分析", route: "/InformationService" },
        { id: 6, name: "物流大屏", route: "/employmentBig" },
        { id: 7, name: "系统设置", route: "/system" },
      ],
      showUserMenu: false,

      timer: null
    };
  },
  mounted() {
    if (localStorage.getItem('token')) {
      this.activeMainMenu = this.$route.meta.fatherRoute;
      document.addEventListener('click', this.handleClickOutside);
      if (document.getElementById("time")) {
        this.timer = setInterval(() => {
          var vWeek, vWeek_s, vDay, year, month, day, hours, minutes, seconds;
          vWeek = ["星期天", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
          var date = new Date();
          year = date.getFullYear();
          month = date.getMonth() + 1;
          day = date.getDate();
          hours = date.getHours() >= 10 ? date.getHours() : '0' + date.getHours();
          minutes = date.getMinutes() >= 10 ? date.getMinutes() : '0' + date.getMinutes();
          seconds = date.getSeconds() >= 10 ? date.getSeconds() : '0' + date.getSeconds();
          vWeek_s = date.getDay();
          let timeinnerHTML = year + "年" + month + "月" + day + "日" + "\t" + vWeek[vWeek_s] + "\t" + hours + ":" + minutes + ":" + seconds;
          document.getElementById("time").innerHTML = timeinnerHTML
        }, 1000);
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    async webGetuserinfo() {
      let res = await this.$api.webGetuserinfo()
      if (res.code == 1) {
        this.userinfo = res.data
      }
    },
    dropdowncommand(command) {
      // 个人中心
      if (command == 1) {
        this.activeMainMenu = '/system'
        this.$router.push('/personalCenter')
      } else if (command == 2) {
        this.handleLogout()
      } else if (command == 21) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/mployed')
      } else if (command == 22) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/unemployed')
      } else if (command == 23) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/keyAnalysis')
      } else if (command == 24) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/migrantWorkers')
      } else if (command == 25) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/keyAnalysis?type=5')
      } else if (command == 26) {
        this.activeMainMenu = '/mployed'
        this.$router.push('/keyAnalysis?type=6')
      } else if (command == 41) {
        this.activeMainMenu = '/portrait'
        this.$router.push('/portrait')
      } else if (command == 42) {
        this.activeMainMenu = '/portrait'
        this.$router.push('/laborForce')
      } else if (command == 51) {
        this.activeMainMenu = '/InformationService'
        this.$router.push('/InformationService')
      } else if (command == 71) {
        this.activeMainMenu = '/system'
        this.$router.push('/system')
      }
    },
    //点击操作
    handleMPopover(type, item) {
      if (type == "退出登录") {
        this.popupObj.type = "退出登录";
        this.popupObj.flag = true;
      }
    },
    async popupCell(val) {
      if (val.submitFlag) {
        if (this.popupObj.type == "退出登录") {
          this.handleLogout()
        }
      }
      this.popupObj.flag = false;
    },
    async indexGetinfo() {
      let res = await this.$api.indexGetinfo()
      if (res.code == 1) {
        res.data.headimage = res.data.headimage ? this.urls + res.data.headimage : ''
        this.userinfo = res.data

        localStorage.setItem('userinfo', JSON.stringify(this.userinfo))
      }
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    handleClickOutside(event) {
      const container = this.$refs.userInfoRef;
      if (!container) return;
      if (!container.contains(event.target)) {
        this.showUserMenu = false;
      }
    },
    handleLogout() {
      try {
        // 清理本地登录状态
        localStorage.removeItem('token');
        localStorage.removeItem('userinfo');
      } catch (e) { console.warn('清理本地登录状态失败', e) }
      this.showUserMenu = false;
      this.$message && this.$message.success && this.$message.success('已退出登录');
      this.$router.push('/login');
    },
    selectMainMenu(item) {

      // this.activeSubMenu = 0; // 重置子菜单选中状态

      // 如果不是活动管理，隐藏子菜单
      if (item.route) {
        this.activeMainMenu = item.route;
        this.$router.push(item.route);
      } else {
        this.$message.info('正在开发中...');
      }
    }
  },
  watch: {
    navArr: {
      handler() { },
      deep: true,
    },
    $route: {
      handler() {
        this.mainMenuItems.forEach((item) => {
          if (this.$route.meta.fatherRoute == item.route) {
            // this.navId = item.id;
            this.activeMainMenu = this.$route.meta.fatherRoute;
          }
        });

        this.webGetuserinfo()
      },
      deep: true,
      immediate: true
    },
  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 170px;
  padding: 0 27px;
}

.header_box {
  width: 100%;
  height: 170px;
  background: url("@/assets/images/public/index_top2.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;

}

.header_box_info {
  width: 100%;
  height: 124px;
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  justify-content: space-between;
  padding: 23px 150px 0 150px;

  .header_box_info_l {
    // width: 220px;
    font-size: 16px;
    color: #7382c4;
  }

  .header_box_info_c {
    font-size: 38px;
    letter-spacing: 2px;
    color: #bfd1ef;
  }

  .header_box_info_r {
    width: 220px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;

    img {
      width: 14px;
      height: 17px;
    }

    span {
      font-size: 16px;
      color: #7382c4;
      margin-left: 9px;
    }
  }
}

.header_box_nav {
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  .header_box_nav {
    width: 193px;
    height: 40px;
    font-size: 18px;
    color: #ffffff;
    background: url("@/assets/images/public/nav.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;
    cursor: pointer;

    &:nth-child(1) {
      margin-left: 0;
    }
  }

  .header_box_nav_act {
    background: url("@/assets/images/public/nav_act.png");
  }
}


.el-dropdown-menu {
  width: 170px;
  background-color: #16233c;
  border-style: solid;
  border-width: 1px;
  border-image-source: linear-gradient(0deg,
      #4279b1 0%,
      #4279b1 100%);
  border-image-slice: 1;
  padding: 0;

  .el-dropdown-menu__item {
    height: 45px;
    line-height: 45px;
    font-size: 15px;
    color: #ffffff;

    &:focus,
    :hover {
      background-color: #108ee9;
    }
  }

  .el-dropdown-menu__item:focus,
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #108ee9;
  }
}
</style>